import React from 'react';
import styled from 'styled-components';
import type { ProductListConciergeEntry } from './product-list-concierge-content';

const Card = styled.section`
  grid-column: 1 / -1;
  width: 100%;
  padding: 16px;
  border: 1px solid currentColor;
`;

/** Functional placeholder; the themed design is a separate PR. */
export function ProductListConciergeCard({ content, onClick }: ProductListConciergeEntry): JSX.Element {
  return (
    <Card aria-label='AI Concierge' data-testid='product-list-concierge-card'>
      <p>{content.sectionLabel}</p>
      <h2>{content.headline}</h2>
      <p>{content.subtext}</p>
      <button type='button' onClick={onClick}>
        {content.button}
      </button>
    </Card>
  );
}
